module.exports = __webpack_public_path__ + "img/1.03.1b17f924.jpg";